import PropTypes from 'prop-types';
import React from 'react';

import ContentfulImage from '../Common/ContentfulImage';
import { ArrowLink } from '../Common/Links';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import * as styles from './List.module.scss';

export default function List({
  items = [],
  heading,
  eyebrowText,
  accentColor,
  flipped,
  backgroundColor,
  onCta,
  ctaUrl,
  ctaLabel,
}) {
  const listItems = items.map((item, i) => (
    <li data-analytics-component={'list-item'} data-analytics-id={item.title} key={i} className={styles.item}>
      <span className={styles.number}>{String(i + 1).padStart(2, '0')}</span>
      <h7 className={styles.heading}>{item.title}</h7>
      <div className={styles.description}>
        <RichTextConverter copy={item.copy} />
      </div>
    </li>
  ));

  const image = <ContentfulImage className={styles.image} lazy={true} imageFragment={items?.[0]?.mainImage} />;

  return (
    <div
      className={[styles.list, flipped ? styles.flipped : '', styles[backgroundColor]].join(' ')}
      data-analytics-component={'list'}
    >
      <div className={styles.content}>
        {eyebrowText && (
          <div className={[styles.eyebrowText, accentColor ? styles[accentColor] : ''].join(' ')}>{eyebrowText}</div>
        )}
        <div className={styles.mobileImage}>{image}</div>
        <h3 className={styles.mainHeading}>{heading}</h3>
        <ul>{listItems}</ul>
        {ctaLabel && !ctaUrl && (
          <div className={styles.cta}>
            <ArrowLink label={ctaLabel} onClick={onCta} />
          </div>
        )}
        {ctaLabel && ctaUrl && (
          <div className={styles.cta}>
            <ArrowLink label={ctaLabel} url={ctaUrl} />
          </div>
        )}
      </div>
      {image}
    </div>
  );
}

List.propTypes = {
  items: PropTypes.array,
  heading: PropTypes.string,
  eyebrowText: PropTypes.string,
  accentColor: PropTypes.string,
  flipped: PropTypes.bool,
  backgroundColor: PropTypes.string,
  subheading: PropTypes.string,
  onCta: PropTypes.func,
  ctaUrl: PropTypes.string,
  ctaLabel: PropTypes.string,
};
